import { store as auth} from '@/modules/auth';

export default {
    auth
}